import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';

import Chip from '@glass/web/components/base/Chip';
import alpha from '@glass/web/modules/theme/alpha';
import makeStyles from '@glass/web/modules/theme/makeStyles';

const useStyles = makeStyles()((theme) => ({
  root: {
    fontWeight: 500,
    transition: theme.transitions.create(['opacity', 'background']),
    textDecoration: 'none!important',
  },
  loading: {
    minWidth: 90,
    opacity: 0.5,
  },
}));

function ContentTag({ label, tag, slug, size, loading, variant, component, href, onClick, color }) {
  const { cx, classes } = useStyles();
  const [isHover, setIsHover] = useState(false);

  const setHoverTrue = useCallback(() => setIsHover(true), []);
  const setHoverFalse = useCallback(() => setIsHover(false), []);

  const style = useMemo(
    () => ({
      backgroundColor: isHover ? `${alpha(color, 0.1)}` : undefined,
    }),
    [isHover, color],
  );

  const handleClick = useCallback(
    (evt) => {
      if (typeof onClick === 'function') {
        onClick(evt, slug);
      }
    },
    [onClick, slug],
  );

  return (
    <Chip
      className={cx(classes.root, loading ? classes.loading : undefined)}
      clickable={!loading && !!component}
      component={component}
      href={href}
      label={label}
      size={size}
      slug={component ? slug : undefined}
      style={style}
      tag={component ? tag : undefined}
      variant={variant}
      onClick={handleClick}
      onMouseEnter={setHoverTrue}
      onMouseLeave={setHoverFalse}
    />
  );
}

ContentTag.defaultProps = {
  variant: 'outlined',
};

ContentTag.propTypes = {
  color: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  component: PropTypes.elementType,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  label: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.string,
  // ResourceLink properties
  slug: PropTypes.string,
  tag: PropTypes.string,
  variant: PropTypes.string,
};

ContentTag.displayName = 'ContentTag';

export default React.memo(ContentTag);
